import Button from '@shared/components/Button/Button';
import cx from 'classnames';

import { ReactComponent as X } from 'assets/icons/X.svg';

interface InviteChipProps {
  invitee: string;
  onRemove: (invitee: string) => void;
  hasError?: boolean;
  className?: string;
  displayLabel?: string;
  icon?: React.ReactNode;
}

const InviteChip = ({ invitee, onRemove, hasError = false, className, displayLabel, icon }: InviteChipProps) => {
  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRemove(invitee);
  };

  return (
    <div
      className={cx(
        'flex items-center gap-2 border border-primary-50 bg-primary-10 rounded-full px-2 py-1.5 text-size-sm',
        { '!bg-alert-20 !border-alert-50': hasError },
        className
      )}
    >
      {icon}
      <span className="truncate max-w-[200px] cursor-default">{displayLabel ?? invitee}</span>
      <Button variant="buttonIconGhost" size="neutral" className="!p-0" onClick={handleRemove}>
        <X className="stroke-black h-5 w-5 stroke-1.5" />
      </Button>
    </div>
  );
};

export default InviteChip;
